import React from 'react';
import classNames from 'classnames';

import {
  ImmutableEntity,
} from '@uncinc/react-drupal-core/types';

import { DynamicMediaItem, Text } from '../../../components';

import { ParagraphTextMedia as Type } from '../../../types/uncinc_profile/paragraphs';

interface ParagraphTextMediaProps {
  entity: ImmutableEntity<Type>;
}

const ParagraphTextMedia: React.FC<ParagraphTextMediaProps> = ({
  entity,
}) => {
  const paragraphTextMedia = entity.toJS();
  const uuid = paragraphTextMedia.uuid[0].value;
  const title = paragraphTextMedia.field_title[0]?.value;
  const body = paragraphTextMedia.field_body[0]?.processed;
  const aspectRatio = paragraphTextMedia?.field_aspect_ratio[0]?.value;
  const link = paragraphTextMedia.field_link[0];
  const linkTitle = link?.title;
  const linkUri = link?.alias || link?.uri;
  const linkTarget = link?.options?.attributes?.target;
  const media = paragraphTextMedia.field_media_item[0];
  const containerClass = classNames('ParagraphTextMedia');

  return (
    <div id={uuid} className={containerClass}>
      <Text
        title={title}
        text={body}
        link={linkUri}
        linkText={linkTitle}
        target={linkTarget}
      />
      <DynamicMediaItem media={media} imageAspectRatio={aspectRatio} />
    </div>
  );
};

export default ParagraphTextMedia;
